import { useMemo } from 'react';
import { Device } from '@/types/device';
import { getDeviceStatusDisplay } from '@/utils/device-helpers';

export const useOnlineStatusMap = (devices: Device[]) =>
  useMemo(() => {
    const map = new Map<number, boolean>();
    for (const device of devices) {
      if (!device.unit?.id) continue;
      const unitId = device.unit.id;
      // Tablets resolve to 'Online' via lastSeen; others via connectivity.
      // 'Inactive'/'Offline' both count as not online at the unit level.
      if (getDeviceStatusDisplay(device).text === 'Online') {
        map.set(unitId, true);
      } else if (!map.has(unitId)) {
        map.set(unitId, false);
      }
    }
    return map;
  }, [devices]);

export const getOnlineStatus = (
  onlineStatusMap: Map<number, boolean>,
  unitId: number,
): 'Online' | 'Offline' | undefined => {
  const isOnline = onlineStatusMap.get(unitId);
  if (isOnline === undefined) return undefined;
  return isOnline ? 'Online' : 'Offline';
};
